(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-form"] && !Shopify.designMode) return;
  try {
    (function () {
  const nativeButtonSelector =
    'button[x-ref="actionElement"]';

  const notifyButtonSelector =
    '#dd-notify-me-button';

  function syncNotifyButton() {
    const nativeButtons = document.querySelectorAll(nativeButtonSelector);
    const notifyButton = document.querySelector(notifyButtonSelector);

    if (!notifyButton || !nativeButtons.length) {
      return;
    }

    /*
     * Find the actual Add to Cart / Out of Stock button.
     * This avoids accidentally selecting another theme CTA.
     */
    const nativeButton = Array.from(nativeButtons).find(function (button) {
      const text = button.textContent
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();

      return (
        text.includes('add to cart') ||
        text.includes('out of stock') ||
        text.includes('sold out')
      );
    });

    if (!nativeButton) {
      return;
    }

    const buttonText = nativeButton.textContent
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

    /*
     * Use the text because your theme is already updating it correctly.
     */
    const isOutOfStock =
      buttonText.includes('out of stock') ||
      buttonText.includes('sold out');

    if (isOutOfStock) {
      notifyButton.style.setProperty('display', 'block', 'important');
      notifyButton.hidden = false;
      notifyButton.removeAttribute('aria-hidden');
    } else {
      notifyButton.style.setProperty('display', 'none', 'important');
      notifyButton.hidden = true;
      notifyButton.setAttribute('aria-hidden', 'true');
    }
  }

  /*
   * Check whenever anything in the product area changes.
   */
  const observer = new MutationObserver(function () {
    window.requestAnimationFrame(syncNotifyButton);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: [
      'disabled',
      'class',
      'style',
      'hidden',
      'aria-disabled'
    ]
  });

  /*
   * Your theme fires this when the selected variant changes.
   */
  document.addEventListener('variant-selected', function () {
    setTimeout(syncNotifyButton, 0);
    setTimeout(syncNotifyButton, 100);
    setTimeout(syncNotifyButton, 300);
    setTimeout(syncNotifyButton, 750);
  });

  /*
   * Backup for themes whose variant event does not bubble to document.
   */
  document.addEventListener('change', function () {
    setTimeout(syncNotifyButton, 50);
    setTimeout(syncNotifyButton, 250);
    setTimeout(syncNotifyButton, 750);
  });

  /*
   * Dotdigital may create or restyle its button after page load.
   */
  window.addEventListener('load', function () {
    syncNotifyButton();
    setTimeout(syncNotifyButton, 500);
    setTimeout(syncNotifyButton, 1500);
  });

  syncNotifyButton();
})();
  } catch(e) { console.error(e); }
})();

})();
